import axios from 'axios';
import { USERVARS } from '../Common.js';

export default axios.create({
    baseURL: 'https://csbackend.virabeli.fi:8080/api/web/1.0/',
    headers: {
        Authorization: 'Basic ' + btoa(unescape(encodeURIComponent(USERVARS.API_USER + ':' + USERVARS.API_PASSWORD)))
    }
});